import React from "react";
import PropTypes from "prop-types";
import styles, { spinDurationMs } from "../styles/styles.module.css";
import classnames from "classnames";
import useSpinOffset from "./useSpinOffset";

export const SIZE_LARGE = "large";
export const SIZE_MEDIUM = "medium";
export const SIZE_SMALL = "small";

export const COLOUR_SCHEME_DEFAULT = "default";
export const COLOUR_SCHEME_INVERTED = "inverted";

export const ProgressIndicator = ({
  colourScheme = COLOUR_SCHEME_DEFAULT,
  progressMessage = null,
  size = SIZE_LARGE,
  transparent = true,
}) => {
  const spinOffsetMs = useSpinOffset(parseInt(spinDurationMs));

  return (
    <div
      aria-hidden={true}
      aria-label={progressMessage}
      role="progressbar"
      style={{
        "--spin-offset": `-${spinOffsetMs}ms`,
      }}
      className={classnames(
        styles.progressIndicator,
        styles[colourScheme],
        styles[size],
        {
          [styles["solid"]]: !transparent,
        }
      )}
    />
  );
};

ProgressIndicator.displayName = "ProgressIndicator";

ProgressIndicator.propTypes = {
  colourScheme: PropTypes.oneOf([
    COLOUR_SCHEME_DEFAULT,
    COLOUR_SCHEME_INVERTED,
  ]),
  progressMessage: PropTypes.string,
  size: PropTypes.oneOf([SIZE_LARGE, SIZE_MEDIUM, SIZE_SMALL]),
  transparent: PropTypes.bool,
};
